import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, Input, OnInit
} from '@angular/core';
import { Observable } from 'rxjs';

import { AppFacade } from '@app/app.facade';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { SearchType } from '@search-bar/entities/search-type';
import { Airport } from '@app/modules/core/interfaces/airport';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { HomeItemDetailWidgetType } from '@home-item-detail/entities/home-item-detail';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';
import { ModuleEntity, ModuleEntityGroup } from '@app/entities/modules-country';
import { ChipActionStatus, ChipActionType } from '@design-system/components/molecules/chip-action/entities/chip-action.types';
import { SearchBarBehavior } from '@shared/base-search-bar/entities/search-bar-behavior';
import {
  TypographyFontSize, TypographyFontFamily, TypographyColor
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-home-item-search-desktop',
  templateUrl: './home-item-search-desktop.component.html',
  styleUrls: ['./home-item-search-desktop.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomeItemSearchDesktopComponent implements OnInit {

  @Input() landingDestination: boolean;
  @Input() widgets: (ModuleEntityGroup | ModuleEntity)[];
  @Input() source: EVENT_SOURCE | string;
  @Input() groupSearchTabs = false;

  public switchSelected: SearchType = null;
  public readonly chipActionType = ChipActionType.Long;

  public readonly searchBarBehavior = SearchBarBehavior.OnLandingWidget;

  public readonly fontSize = TypographyFontSize;
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;

  constructor(
    private readonly facade: AppFacade,
    private readonly baseSearchBarFacade: BaseSearchBarFacade,
    @Inject(IS_BROWSER) public isBrowser: boolean
  ) { }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.switchSelected = this.groupSearchTabs ? 
        (this.widgets as ModuleEntityGroup[])?.[0].value?.[0]?.searchType :
        (this.widgets as ModuleEntity[])?.[0].searchType;
    }
  }

  get airports$(): Observable<Airport[]> {
    return this.facade.airports$;
  }

  get homeItemDetailWidgetType(): typeof HomeItemDetailWidgetType {
    return HomeItemDetailWidgetType;
  }

  get searchType(): typeof SearchType {
    return SearchType;
  }

  get hasWidgets(): boolean {
    return !!this.widgets?.length;
  }

  public trackByPosition(index: number, type: SearchType): string {
    return `${index}_${type}`;
  }

  public onClickSwitch(type: SearchType): void {
    this.switchSelected = type;
    this.baseSearchBarFacade.setTabSelectedHome(this.switchSelected);
  }

  public moduleSelected(type: SearchType): boolean {
    return this.switchSelected === type;
  }

  public getChipStatus(moduleIsSelected: boolean): ChipActionStatus {
    return moduleIsSelected ? ChipActionStatus.Selected : ChipActionStatus.Default;
  }
}
